import { useIntl } from 'react-intl'
import ListingDrawerEmptyState from '../ListingDrawerEmptyState'

interface Props {
  placeName: string
  searchUrl: string
}

function HotelListingEmptyState({ placeName, searchUrl }: Props) {
  const intl = useIntl()
  const imageAlt = intl.formatMessage({
    id: 'n15jOY_j88Q7tNPrJvO-',
    defaultMessage: 'No hotels available',
    description: 'Alt text for empty state image when no hotels are found',
  })
  const heading = intl.formatMessage({
    id: 'cCgTm8voUp3ICLIWATWj',
    defaultMessage: 'No hotels available in this area',
    description: 'Heading when no hotel listings found in the selected area',
  })
  const body = intl.formatMessage({
    id: '0cYlzwLE8_gtvXM8bvWY',
    defaultMessage: 'We don’t have any Luxury Escapes deals in {placeName} right now.',
    description: 'Message when no Luxury Escapes hotel deals exist for a specific location',
  }, { placeName })
  const ctaLabel = intl.formatMessage({
    id: 'ICWQS5psHyD8XpzfRzmP',
    defaultMessage: 'View more on Luxury Escapes',
    description: 'Button label to view more hotel deals on Luxury Escapes website',
  })

  return (
    <ListingDrawerEmptyState
      imageAlt={imageAlt}
      heading={heading}
      body={body}
      ctaLabel={ctaLabel}
      searchUrl={searchUrl}
    />
  )
}

export default HotelListingEmptyState
